module.exports = __webpack_public_path__ + "static/si-4924ab78bb2cc4652a4d0edff699b6f8.jpg";